import React, { useEffect, useRef, useState, useContext } from "react";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";
//@Components
import NoData from "../../../Pages/InformativeComponents/NoData.component";
import { checkImage } from "../../utils";
import ShotsPageNewShotModal from "../ShotsPageModals/ShotsPageNewShotModal";
import ShotsPageTools from "../ShotsPageTools/ShotsPageTools.component";
import useStyles from "./ShotsPageOverview.styles";

//@MUI
import { Modal, FormControl, Select, MenuItem } from "@material-ui/core";
import { Typography, IconButton, Box } from "@mui/material";
import { CaretRight, CaretDown } from "phosphor-react";
//@API
import { fget, fpost, fpostBFF } from "../../../API/callsAPI";
import CSVImportModal from "../../Utilities/CSVImportModal/CSVImportModal.jsx";
import ErrorOrSuccessMessage from "../../Utilities/ErrorOrSuccessMessage/ErrorOrSuccessMessage.component";
import ExportModal from "../../Utilities/ExportModal/ExportModal";
import Loader from "../../Utilities/Loader/Loader";
import NewDataLoadingLoader from "../../Utilities/NewDataLoadingLoader/NewDataLoadingLoader.component";
import ShotPageMultiCreate from "../ShotsPageModals/ShotPageMultiCreate";
import ShotsDefaultTable from "../ShotsTable/ShotsDefaultTable.jsx";
import { MovieColabContext } from "../../../Context/MovieColabContext";
import { selectAppliedFilterForTrackable } from "../../../redux/selectors/projectFilters";
import { mapFieldsFromConfig } from "../../Utilities/CustomTableForAllTrackables/fieldMapper.js";
import CustomPagination from "../../Utilities/CustomPagination/CustomPagination.component.jsx";
import ShotsCustomTable from "../ShotsTable/ShotsCustomTable.jsx";

export default function ShotsPageOverview(props) {
  const classes = useStyles();
  const history = useHistory();
  const tableRef = useRef();
  const lastSelectedIndexRef = useRef(null);
  const { trackableClass } = useContext(MovieColabContext);
  const shotTrackableId = trackableClass?.find(
    (trackable) => trackable.model?.toLowerCase() === "shot"
  )?.id;
  const appliedFilter = useSelector((state) =>
    selectAppliedFilterForTrackable(state, shotTrackableId)
  );
  const appliedFilterIds = appliedFilter?.id != null ? [appliedFilter.id] : [];
  const appliedFilterKey = appliedFilter
    ? `${appliedFilter.id}:${JSON.stringify(appliedFilter.filters ?? [])}`
    : "";
  const [sliderState, setSliderState] = React.useState("0");
  const [isNewShotModalOpen, setNewShotModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [shotsList, setShotsList] = useState();
  const [sortByDefault, setSortByDefault] = useState("");
  const [departmentsList, setDepartmentsList] = useState();
  const [departments, setDepartments] = useState();
  const [shotsFilteredStatus, setShotsFilteredStatus] = useState("");
  const [shotsFilteredDepartment, setShotsFilteredDepartment] = useState("");
  const [statusList, setStatusList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoaded, setIsLoaded] = useState(false);
  const [shotPageToggler, setShotPageToggler] = useState(false);
  const [refreshCounter, setRefreshCounter] = useState(0);
  const [file, setFile] = useState("");
  const [dragScreen, setDragScreen] = useState(false);
  //state will be true when we start drag file inside modals
  const [dragFileEnterModal, setDragFileEnterModal] = useState(false);
  const [scrollValue, setScrollValue] = useState("");
  const [updateOnPageChange, setUpdateOnPageChange] = useState(0);
  const [isNewPageLoading, setIsNewPageLoading] = useState(false);
  const [isMultiCreateModalOpen, setIsMultiCreateModalOpen] = useState(false);
  const [shotsStats, setShotsStats] = useState({ total: 0, visibleCount: 0 });
  // bulk update
  const [isMultiSelectEnabled, setIsMultiSelectEnabled] = useState(false);
  const [selectedShots, setSelectedShots] = useState([]);
  const [snackValue, setSnackValue] = useState({
    isOpen: false,
    message: "",
    isError: false,
  });
  const [sequenceList, setSequenceList] = useState([]);
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const [openBulkImportModal, setOpenBulkImportModal] = useState(false);
  const [allFieldsConfig, setAllFieldsConfig] = useState([]);
  const [isToggleView, setIsToggleView] = useState(false);

  const decodedURL = decodeURIComponent(
    escape(window.atob(history.location.search.substring(1)))
  );
  let searchParams = new URLSearchParams(decodedURL);
  //initial bff call
  useEffect(() => {
    if (props.params.sid) {
      fetchShots();
    } else {
      fetchStatuses();
      fetchDepartments();
      fetchSequenceList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.params.sid]);

  useEffect(() => {
    setShotsFilteredStatus(searchParams.get("status") || "");
    setSortByDefault(searchParams.get("sortBy") || "A-Z");
    var scrollStored = JSON.parse(localStorage.getItem("scroll"));
    if (scrollStored) {
      setScrollValue(scrollStored.shots);
    } else {
      const scrollData = {
        asset: "0",
        assetVersion: "0",
        sequence: "0",
        shots: "0",
        shotVersion: "0",
      };
      localStorage.setItem("scroll", JSON.stringify(scrollData));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshCounter]);

  const updateRefreshCounter = () => {
    setRefreshCounter(refreshCounter + 1);
  };

  const handlePageChange = (pageNo) => {
    setCurrentPage(pageNo);
    setUpdateOnPageChange(updateOnPageChange + 1);
  };

  useEffect(() => {
    if (!props.params.sid) {
      fetchAllShots();
    }
    if (
      props.params.sid &&
      (props.params.projectId ||
        parseInt(shotsFilteredStatus) > 0 ||
        updateOnPageChange ||
        refreshCounter)
    ) {
      fetchFilteredShots();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    appliedFilterKey,
    props.params.projectId,
    props.params.sid,
    shotsFilteredStatus,
    shotsFilteredDepartment,
    currentPage,
    updateOnPageChange,
    refreshCounter,
  ]);

  function handleNewShotModalState() {
    setNewShotModalOpen(!isNewShotModalOpen);
  }

  const handleShotPageToggler = () => {
    setShotPageToggler(!shotPageToggler);
  };

  async function fetchFilteredShots() {
    let url = `trackables/shot/v2/?project=${props.params.projectId}&page=${currentPage}&parent_sequence=${props.params.sid}`;
    if (shotsFilteredStatus) {
      url += `&status=${shotsFilteredStatus}`;
    }
    if (sortByDefault) {
      url += `&sortBy=${sortByDefault}`;
    }
    if (shotsFilteredDepartment) {
      url += `&allowed_dept=${shotsFilteredDepartment}`;
    }
    appliedFilterIds.forEach((filterId) => {
      url += `&filter=${filterId}`;
    });

    try {
      const res = await fget({ url });
      setShotsList(res?.data);
      setIsLoaded(true);
      setIsNewPageLoading(false);
    } catch (error) {
      setIsNewPageLoading(false);
      console.error("Error loading filtered shots", error);
    }
    history.push("?" + btoa(unescape(encodeURIComponent(url.split("?")[1]))));
  }

  //post req bff to get projectDetails,status,shot
  const fetchShots = async () => {
    const shots = {
      url: "web/shot/list/",
      data: {
        project_id: props.params.projectId,
        sequence_id: props.params.sid,
      },
    };
    try {
      const res = await fpostBFF(shots);
      setStatusList(res?.data.status_list.results);
      setDepartmentsList(res?.data?.department_list?.results);
      if (
        searchParams.get("status") === null ||
        searchParams.get("status") === ""
      ) {
        setIsLoaded(true);
      }
      setShotsStats((prevData) => ({
        ...prevData,
        visibleCount: res.data.shot_list.count,
      }));
      setDepartments(
        res?.data?.department_list?.results.map((el) => {
          const data = {
            title: el.name,
            id: el.id,
          };
          return data;
        })
      );
      window.scrollTo(0, sessionStorage.getItem("scrollpos"));
    } catch (error) {
      console.log(error);
      setSnackValue({
        isOpen: true,
        message: `Error on loading shots`,
        isError: true,
      });
      setIsLoaded(true);
    }
  };

  const fetchStatuses = async () => {
    try {
      const res = await fget({
        url: `trackables/status/?project=${props.params.projectId}`,
      });
      setStatusList(res?.data?.results);
    } catch (error) {
      console.log(error);
      setSnackValue({
        isOpen: true,
        message: `Error on loading statuses`,
        isError: true,
      });
    }
  };

  const fetchDepartments = async () => {
    try {
      const res = await fget({
        url: `department/?project=${props.params.projectId}`,
      });
      setDepartmentsList(res?.data.results);
      setDepartments(
        res?.data?.results.map((el) => {
          const data = {
            title: el.name,
            id: el.id,
          };
          return data;
        })
      );
    } catch (error) {
      console.log(error);
      setSnackValue({
        isOpen: true,
        message: `Error on loading departments`,
        isError: true,
      });
    }
  };

  const fetchAllShots = async () => {
    try {
      const res = await fget({
        url: `trackables/shot/?page=${currentPage}&project=${props.params.projectId}&status=${shotsFilteredStatus}&sortBy=${sortByDefault}&allowed_dept=${shotsFilteredDepartment}`,
      });
      setShotsList(res?.data);
      setIsLoaded(true);
      setIsNewPageLoading(false);
    } catch (error) {
      console.log(error);
      setSnackValue({
        isOpen: true,
        message: `Error on loading shots`,
        isError: true,
      });
    }
  };

  async function fetchFile(id) {
    if (id) {
      // fetching the signed url only if file is there

      try {
        const res = await fget({
          url: `trackables/shot/${id}/file`,
        });
        setFile(res?.data?.signed_url);
      } catch (error) {
        setFile("");
        console.log(error);
      }
    } else setFile("");
  }

  useEffect(() => {
    if (shotsList) {
      const fields = mapFieldsFromConfig(
        shotsList?.fields_config,
        shotsList?.custom_fields,
        shotsList?.default_fields,
        true
      );
      setAllFieldsConfig(fields);
    }
    shotsList?.results &&
      searchParams.get("sortBy") &&
      handleSubmitSort(searchParams.get("sortBy"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shotsList]);

  //Function to sort Shots
  function handleSubmitSort(sortBy) {
    searchParams.set("sortBy", `${sortBy}`);
    history.push(
      "?" + btoa(unescape(encodeURIComponent(searchParams.toString())))
    );
    switch (sortBy) {
      case "A-Z":
        shotsList?.results?.sort((a, b) => a.code.localeCompare(b.code));
        setSortByDefault("A-Z");
        break;
      case "Z-A":
        shotsList?.results?.sort((a, b) => b.code.localeCompare(a.code));
        setSortByDefault("Z-A");
        break;
      case "LatestModified":
        shotsList?.results?.sort(function (a, b) {
          var dateA = new Date(a.updated_at),
            dateB = new Date(b.updated_at);
          return dateB - dateA;
        });
        setSortByDefault("LatestModified");
        break;
      case "LastModified":
        shotsList?.results?.sort(function (a, b) {
          var dateA = new Date(a.updated_at),
            dateB = new Date(b.updated_at);
          return dateA - dateB;
        });
        setSortByDefault("LastModified");
        break;
      case "DateCreated":
        shotsList?.results?.sort(function (a, b) {
          var dateA = new Date(a.created_at),
            dateB = new Date(b.created_at);
          return dateA - dateB;
        });
        setSortByDefault("DateCreated");
        break;
      default:
        return shotsList?.results;
    }
  }

  //event to save scrollBar position
  window.onbeforeunload = function (e) {
    sessionStorage.setItem("scrollpos", window.scrollY);
  };

  const handleDragFile = (e) => {
    setDragScreen(true);
    if (e.type === "drop") {
      //if we drop file , removing drag zone screen
      setDragScreen(false);
    }
    if (e.type === "dragleave") {
      //if we leave the drag file , removing drag zone screen
      if (dragFileEnterModal) {
        setDragScreen(true);
      } else {
        setDragScreen(false);
      }
    }
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragScreen = (el) => {
    setDragScreen(el);
  };

  let scrollTimer = null;
  const handleTableScroll = (e) => {
    if (scrollTimer !== null) clearTimeout(scrollTimer);

    scrollTimer = setTimeout(() => {
      searchParams.set("scroll", `${e.target.scrollTop}`);
      history.push(
        "?" + btoa(unescape(encodeURIComponent(searchParams.toString())))
      );
      let scrollStored = JSON.parse(localStorage.getItem("scroll"));
      scrollStored.shots = e.target.scrollTop;
      localStorage.setItem("scroll", JSON.stringify(scrollStored));
    }, 700);
  };

  const getShotsStats = async () => {
    try {
      const shotsRes = await fget({
        url: `trackables/trackable-count/shot/${props.params.sid}/`,
      });
      setShotsStats((prevData) => ({
        ...prevData,
        total: shotsRes?.data?.instances,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (props.params.sid) {
      getShotsStats();
    }
  }, [refreshCounter]);

  const handleSelectOrUnSelectShot = (shot, index, e) => {
    if (e.shiftKey && lastSelectedIndexRef.current !== null) {
      const start = Math.min(lastSelectedIndexRef.current, index);
      const end = Math.max(lastSelectedIndexRef.current, index);
      const shotsInRange = shotsList.results.slice(start + 1, end + 1);
      setSelectedShots((prev) => {
        const existingIds = new Set(prev.map((s) => s.id));
        const toAdd = shotsInRange.filter((s) => !existingIds.has(s.id));
        return [...prev, ...toAdd];
      });
    } else {
      const isExist = selectedShots?.find((sin) => sin.id === shot.id);
      if (isExist) {
        const others = selectedShots.filter((sin) => sin.id !== shot.id);
        setSelectedShots(others);
      } else {
        setSelectedShots((selectedShots) => [...selectedShots, shot]);
      }
      lastSelectedIndexRef.current = index;
    }
  };

  const handleBulkUpdateStatus = async (statusId) => {
    try {
      const postData = {
        url: "trackables/bulk-update-trackable/",
        data: {
          ids: selectedShots?.map((sin) => sin.id),
          status: statusId,
        },
      };
      const res = await fpost(postData);
      setIsMultiSelectEnabled(false);
      setSelectedShots([]);
      if (!props.params.sid) {
        fetchAllShots();
      } else {
        fetchFilteredShots();
      }
    } catch (error) {
      console.log(error);
    }
  };

  //get sequence list
  const fetchSequenceList = async () => {
    try {
      const res = await fget({
        url: `trackables/shot-sequence/?project=${props.params.projectId}`,
      });
      setSequenceList(res?.data.results);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchAllShotData = async () => {
    const PAGE_SIZE = 50;
    const firstRes = await fget({
      url: `trackables/shot/?page=1&project=${props.params.projectId}&parent_sequence=${props.params.sid}&status=${shotsFilteredStatus}&?allowed_dept=${shotsFilteredDepartment}`,
    });
    const totalCount = firstRes.data.count;
    const totalPages = Math.ceil(totalCount / PAGE_SIZE);

    if (totalPages <= 1) {
      return firstRes.data.results;
    }

    const remainingPromises = Array.from({ length: totalPages - 1 }, (_, i) =>
      fget({
        url: `trackables/shot/?page=${i + 2}&project=${
          props.params.projectId
        }&parent_sequence=${
          props.params.sid
        }&status=${shotsFilteredStatus}&?allowed_dept=${shotsFilteredDepartment}`,
      })
    );
    const remainingResults = await Promise.all(remainingPromises);

    return [
      ...firstRes.data.results,
      ...remainingResults.flatMap((res) => res.data.results),
    ];
  };

  const createShotInBulk = async (
    tableData,
    columnMappings,
    trackableType,
    defaultFields = []
  ) => {
    const validApiFields = new Set(defaultFields.map((f) => f.name));
    const shots = tableData.map((row) =>
      Object.fromEntries(
        Object.entries(columnMappings)
          .filter(
            ([, apiField]) =>
              apiField && apiField !== "none" && validApiFields.has(apiField)
          )
          .map(([csvHeader, apiField]) => [apiField, row[csvHeader]])
      )
    );
    shots.forEach((shot) => {
      shot.project = props.params.projectId;
      shot.vp_linked_level_sequence = "";
      shot.parent_sequence = props.params.sid;
    });
    try {
      const res = await fpost({
        url: `trackables/shot/v2/`,
        data: shots,
      });
      if (res.status === 200 || 201) {
        updateRefreshCounter();
        setSnackValue({
          isOpen: true,
          message: "Shots imported successfully",
          isError: false,
        });
        return true;
      } else {
        setSnackValue({
          isOpen: true,
          message: "Error importing shots",
          isError: true,
        });
        return false;
      }
    } catch (error) {
      console.log(error);
      setSnackValue({
        isOpen: true,
        message: error.response.data.detail || "Error importing shots",
        isError: true,
      });
    }
  };
  const handleStatusChange = (value) => {
    setShotsFilteredStatus(value);
    if (value === "") {
      history.replace(history.location.pathname);
      window.location.reload();
    }
  };

  if (props.embedded) {
    const nameStatus =
      statusList.find((el) => el.id === shotsFilteredStatus)?.name || "";
    return (
      <>
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box style={{ display: "flex", alignItems: "center", gap: "4px" }}>
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: "bold",
                color: "#606479",
                cursor: "pointer",
                "&:hover": { color: "white" },
              }}
              onClick={() =>
                props.setViewMode({
                  sequence: true,
                  shots: false,
                  seqId: null,
                  shotId: null,
                  seqName: null,
                  shotName: null,
                })
              }
            >
              {props.viewMode.seqName}
            </Typography>
            <IconButton>
              <CaretRight size={16} color="#606479" />
            </IconButton>
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: "bold",
                color: "#606479",
                cursor: "pointer",
                "&:hover": { color: "white" },
              }}
              onClick={() =>
                props.setViewMode({
                  sequence: false,
                  shots: true,
                  seqId: null,
                  shotId: null,
                  seqName: null,
                  shotName: null,
                })
              }
            >
              Shots
            </Typography>
          </Box>
          <FormControl
            variant="outlined"
            className={classes.formControl}
            style={{ marginRight: "10px" }}
          >
            <div
              style={{ justifyContent: "space-between" }}
              className={classes.dropdownDiv}
            >
              <text className={classes.selectText}>
                {shotsFilteredStatus ? nameStatus : "Select By Status"}
              </text>
              <CaretDown size={16} color="#606479" />
            </div>
            <Select
              className={classes.formLabelText}
              labelId="demo-simple-select-outlined-label"
              id="selectStatus"
              label="Select Status"
              value={shotsFilteredStatus}
              onChange={(event) => {
                handleStatusChange(event.target.value[0]);
              }}
              MenuProps={{
                classes: {
                  paper: classes.dropDown,
                },
              }}
            >
              <MenuItem value={["", "None"]}>
                <em>None</em>
              </MenuItem>
              {statusList &&
                statusList.map((el) => (
                  <MenuItem value={[el.id, el.name]} key={el.id}>
                    {el.name} - {el.id}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Box>
        {!isLoaded && <Loader />}
        {isLoaded && shotsList && shotsList.count === 0 && <NoData />}
        {shotsList && shotsList.count !== 0 && (
          <>
            <ShotsDefaultTable
              embedded={true}
              shotsList={shotsList}
              isMultiSelectEnabled={isMultiSelectEnabled}
              selectedShots={selectedShots}
              setSelectedShots={setSelectedShots}
              shotPageToggler={shotPageToggler}
              updateRefreshCounter={updateRefreshCounter}
              setIsViewModalOpen={setIsViewModalOpen}
              fetchFile={fetchFile}
              dragScreen={dragScreen}
              handleDragScreen={handleDragScreen}
              setDragFileEnterModal={setDragFileEnterModal}
              departmentsList={departmentsList}
              sliderState={sliderState}
              handleTableScroll={handleTableScroll}
              tableRef={tableRef}
              scrollValue={scrollValue}
              currentPage={currentPage}
              setIsNewPageLoading={setIsNewPageLoading}
              handlePageChange={handlePageChange}
              statusList={statusList}
              sequenceId={props.params.sid}
              projectId={props.params.projectId}
              handleSelectOrUnSelectShot={handleSelectOrUnSelectShot}
            />
            {shotsList.count > 50 && (
              <footer style={{ bottom: "0", height: "100%" }}>
                <div>
                  <CustomPagination
                    handlePageChange={handlePageChange}
                    currentPage={currentPage}
                    totalItem={shotsList.count}
                    totalPage={Math.ceil(shotsList.count / 50)}
                    setIsNewPageLoading={setIsNewPageLoading}
                  />
                </div>
              </footer>
            )}
          </>
        )}
      </>
    );
  }

  return (
    <div
      className={classes.root}
      onDragEnter={(e) => handleDragFile(e)}
      onDrop={(e) => handleDragFile(e)}
      onDragLeave={(e) => handleDragFile(e)}
      onDragOver={(e) => handleDragFile(e)}
    >
      <ErrorOrSuccessMessage snackValue={snackValue} />
      <ShotsPageTools
        handleSliderChange={(value) => {
          setSliderState(value);
          sessionStorage.setItem("sliderState", `${sliderState}`);
        }}
        sliderState={sliderState}
        openNewShotModal={handleNewShotModalState}
        handleBackButton={() =>
          history.replace(
            history.location.pathname.split("/").slice(0, -2).join("/")
          )
        }
        status={statusList}
        departmentsList={departmentsList}
        handleStatusChange={handleStatusChange}
        handleDepartmentChange={(value) => setShotsFilteredDepartment(value)}
        filterValues={{
          status: shotsFilteredStatus,
          department: shotsFilteredDepartment,
        }}
        handleShotPageToggler={handleShotPageToggler}
        onSubmit={handleSubmitSort}
        defaultvalue={sortByDefault}
        shotsStats={shotsStats}
        handleToggleMultiSelect={() =>
          setIsMultiSelectEnabled(!isMultiSelectEnabled)
        }
        isMultiSelectEnabled={isMultiSelectEnabled}
        selectedShots={selectedShots}
        handleBulkUpdateStatus={(status) => handleBulkUpdateStatus(status)}
        handleClearSelection={() => setSelectedShots([])}
        handleOpenExportModal={() => setIsExportModalOpen(true)}
        handleMultiCreateModalOpen={() => setIsMultiCreateModalOpen(true)}
        handleNewCreateModalOpen={() => setNewShotModalOpen(true)}
        handleOpenBulkImportModal={() => setOpenBulkImportModal(true)}
        projectId={props.params.projectId}
        isToggleView={isToggleView}
        handleToggleView={() => setIsToggleView(!isToggleView)}
      />
      {!isLoaded && <Loader />}
      {isLoaded && shotsList && shotsList.count === 0 && <NoData />}
      {shotsList && shotsList.count !== 0 && (
        <>
          {isToggleView ? (
            <ShotsCustomTable
              shotsList={shotsList}
              isMultiSelectEnabled={isMultiSelectEnabled}
              selectedShots={selectedShots}
              setSelectedShots={setSelectedShots}
              shotPageToggler={shotPageToggler}
              updateRefreshCounter={updateRefreshCounter}
              setIsViewModalOpen={setIsViewModalOpen}
              fetchFile={fetchFile}
              dragScreen={dragScreen}
              handleDragScreen={handleDragScreen}
              setDragFileEnterModal={setDragFileEnterModal}
              departmentsList={departmentsList}
              sliderState={sliderState}
              handleTableScroll={handleTableScroll}
              tableRef={tableRef}
              scrollValue={scrollValue}
              currentPage={currentPage}
              setIsNewPageLoading={setIsNewPageLoading}
              handlePageChange={handlePageChange}
              statusList={statusList}
              sequenceId={props.params.sid}
              projectId={props.params.projectId}
              handleSelectOrUnSelectShot={handleSelectOrUnSelectShot}
              allFieldsConfig={allFieldsConfig}
            />
          ) : (
            <ShotsDefaultTable
              shotsList={shotsList}
              isMultiSelectEnabled={isMultiSelectEnabled}
              selectedShots={selectedShots}
              setSelectedShots={setSelectedShots}
              shotPageToggler={shotPageToggler}
              updateRefreshCounter={updateRefreshCounter}
              setIsViewModalOpen={setIsViewModalOpen}
              fetchFile={fetchFile}
              dragScreen={dragScreen}
              handleDragScreen={handleDragScreen}
              setDragFileEnterModal={setDragFileEnterModal}
              departmentsList={departmentsList}
              sliderState={sliderState}
              handleTableScroll={handleTableScroll}
              tableRef={tableRef}
              scrollValue={scrollValue}
              currentPage={currentPage}
              setIsNewPageLoading={setIsNewPageLoading}
              handlePageChange={handlePageChange}
              statusList={statusList}
              sequenceId={props.params.sid}
              projectId={props.params.projectId}
              handleSelectOrUnSelectShot={handleSelectOrUnSelectShot}
            />
          )}
          {shotsList.count > 50 && (
            <footer style={{ bottom: "0", height: "100%" }}>
              <div>
                <CustomPagination
                  handlePageChange={handlePageChange}
                  currentPage={currentPage}
                  totalItem={shotsList.count}
                  totalPage={Math.ceil(shotsList.count / 50)}
                  setIsNewPageLoading={setIsNewPageLoading}
                />
              </div>
            </footer>
          )}
        </>
      )}

      <Modal className={classes.shotsPageModals} open={isNewPageLoading}>
        <NewDataLoadingLoader trackable="Shots" />
      </Modal>
      <Modal
        className={classes.shotsPageModals}
        open={isNewShotModalOpen}
        onClose={() => setNewShotModalOpen(false)}
      >
        <ShotsPageNewShotModal
          dragScreen={dragScreen}
          handleDragScreen={handleDragScreen}
          setDragFileEnterModal={setDragFileEnterModal}
          departments={departments}
          projectId={props.params.projectId}
          sequenceId={props.params.sid}
          status={statusList}
          handleNewShotModal={handleNewShotModalState}
          updateRefreshCounter={updateRefreshCounter}
          sequenceList={sequenceList}
          customFields={shotsList?.custom_fields}
        />
      </Modal>
      <Modal
        className={classes.shotsPageModals}
        open={isViewModalOpen}
        onClose={() => {
          setIsViewModalOpen(false);
        }}
      >
        {file ? (
          checkImage(file) ? (
            <img
              src={file}
              alt="shot-img"
              className="card-img-top"
              style={{ width: "500px", height: "auto" }}
            />
          ) : (
            <video
              src={file}
              controls
              autoPlay
              style={{ width: "auto", height: "500px" }}
            />
          )
        ) : (
          <span>No file found</span>
        )}
      </Modal>

      <Modal
        className={classes.shotsPageModals}
        open={isMultiCreateModalOpen}
        onClose={() => setIsMultiCreateModalOpen(false)}
      >
        <ShotPageMultiCreate
          sequenceList={sequenceList}
          projectId={props.params.projectId}
          sequenceId={props.params.sid}
          setIsMultiCreateModalOpen={setIsMultiCreateModalOpen}
          updateRefreshCounter={updateRefreshCounter}
        />
      </Modal>

      <Modal
        className={classes.shotsPageModals}
        open={openBulkImportModal}
        onClose={() => setOpenBulkImportModal(false)}
      >
        <CSVImportModal
          createInBulk={createShotInBulk}
          trackableType="shot"
          closeModal={() => setOpenBulkImportModal(false)}
          projectId={props.params.projectId}
          requiredFields={["Code(name)"]}
        />
      </Modal>
      <Modal
        className={classes.shotsPageModals}
        open={isExportModalOpen}
        onClose={() => {
          setIsExportModalOpen(false);
        }}
      >
        <ExportModal
          headersList={["Shot Name", "Last Modified", "Description", "Status"]}
          valuesList={[
            { name: "code", type: "string" },
            { name: "updated_at", type: "date" },
            { name: "description", type: "string" },
            { name: "status", type: "object", key: "name" },
          ]}
          fetchAllData={fetchAllShotData}
          handleClose={() => setIsExportModalOpen(false)}
        />
      </Modal>
    </div>
  );
}
